/**
 * This store is responsible for holding information about
 * images being uploaded
 */
 import AppDispatcher from '../dispatcher/app-dispatcher'
 import assign from 'lodash/assign'

 const EventEmitter = require('events').EventEmitter
 const CHANGE_EVENT = 'change';

var importedImages = {};
var selectedImages = {};
var selectedViewData = {
	type: 'timeline'
};
var previousSelectedImage = null;
var events = [];
var collections = [];
var timeline = [];


function toggleImageSelect (image) {
	previousSelectedImage = image.ImageId;
	if (selectedImages.hasOwnProperty(image.ImageId)) {
		delete selectedImages[image.ImageId];
	} else {
		selectedImages[image.ImageId] = image;
	}
}

function selectImages(imageList) {
	for (var i = 0; i < imageList.length; i++) {
		var image = imageList[i];
		selectedImages[image.ImageId] = image;
	}
}

function deselectImages(imageList) {
	for (var i = 0; i < imageList.length; i++) {
		var image = imageList[i];
		delete selectedImages[image.ImageId];
	}
}

function toggleImageImport (imageId) {
	if (importedImages.hasOwnProperty(imageId)) {
		importedImages[imageId] = !importedImages[imageId];
	} else {
		importedImages[imageId] = true;
	}
}

function setTimelineData (timelineData) {
	timeline = timelineData;
}

function setEventsData (eventsData) {
	events = eventsData;
}


function setCollectionsData (collectionsData) {
	collections = collectionsData;
}

/**
 * This will select multiple images, starting
 * with the previous image clicked and up to the given image
 * Just like shift-key selection in windows and mac
 * @param  {string} imageId   [description]
 * @param  {array} photoList [description]
 */
function shiftSelect (imageId, photoList) {
	if (previousSelectedImage) {
		var started = false;
		for (var i = 0; i < photoList.length; i++) {
			if (photoList[i].ImageId === previousSelectedImage) { //We found the previous clicked image, start marking images as selected
				selectedImages[photoList[i].ImageId] = photoList[i];
				started = true;
				continue;
			}
			if (photoList[i].ImageId === imageId) { //We found the image that was clicked now, stop marking images and quit the loop
				selectedImages[imageId] = photoList[i];
				previousSelectedImage = imageId;
				break;
			}

			if (started) { //We found a photo that is between the previous clicked image and the clicked image, so mark it as selected
				selectedImages[photoList[i].ImageId] = photoList[i];
			}
		}
	}
}

function deleteSelection() {
	selectedImages = {};
}

function setSelectedView(data) {
	selectedViewData = data;
}


var PhotoorganiseStore = assign({}, EventEmitter.prototype, {
	dispatcherIndex: AppDispatcher.register(function(payload) {
		var action = payload.action;
		switch(action.actionType) {
			case 'toggleImageSelect':
				toggleImageSelect(action.image);
				PhotoorganiseStore.emitChange();
			break;
			case 'selectImages':
				selectImages(action.imageList);
				PhotoorganiseStore.emitChange();
			break;
			case 'deselectImages':
				deselectImages(action.imageList);
				PhotoorganiseStore.emitChange();
			break;
			case 'toggleImageImport':
				toggleImageImport(action.imageId);
				PhotoorganiseStore.emitChange();
			break;
			case 'shiftSelect':
				shiftSelect(action.imageId, action.photoList);
				PhotoorganiseStore.emitChange();
			break;
			case 'deleteSelection':
				deleteSelection();
				PhotoorganiseStore.emitChange();
			break;
			case 'setSelectedView':
				setSelectedView(action.data);
				PhotoorganiseStore.emitChange();
			break;
			case 'setEventsData':
				setEventsData(action.data);
				PhotoorganiseStore.emitChange();
			break;
			case 'setCollectionsData':
				setCollectionsData(action.data);
				PhotoorganiseStore.emitChange();
			break;
			case 'setTimelineData':
				setTimelineData(action.data);
				PhotoorganiseStore.emitChange();
			break;
		}
		return true;
	}),
	getData: function () {
		return {selection: selectedImages, imported: importedImages, selectedViewData: selectedViewData, timeline: timeline, collections: collections, events: events};
	},
	emitChange: function() {
		this.emit(CHANGE_EVENT);
	},

	addChangeListener: function(callback) {
		this.addListener(CHANGE_EVENT, callback);
	},

	removeChangeListener: function(callback) {
		this.removeListener(CHANGE_EVENT, callback);
	}
});

export default PhotoorganiseStore;
